import { Hero, Description, Platforms, Comparison, AdFormats, Targeting, Examples, Packages, Offer } from '../../components/smartTvAdvertising/sections';

const SmartTvAdvertising = () => {
  return (
    <div className="MontserratArm">
      <Hero />
      <Description />
      <Platforms />
      <Comparison />
      <AdFormats />
      <Targeting />
      <Examples />
      <Packages />
      <Offer />
    </div>
  );
};

export default SmartTvAdvertising;
